<template>
    <app-layout title="Bestekken">
        <template #header>
            <page-title title="Bestekken" />
        </template>

        <template #pageContent>
            <div class="flex justify-between w-1/2">
                <TableSearch tableId="overview-estimates" :values="estimates" class="w-1/2" placeholder="Zoeken"/>

                <Button
                    htmlType="a"
                    buttonClass="add"
                    text="Bestek toevoegen"
                    :href="route('estimates.new')"
                />
            </div>

            <Table id="overview-estimates" :values="estimates" class="w-1/2 mt-4">
                <thead>
                    <tr>
                        <Th id="name">Bestek</Th>
                        <Th id="status">Status</Th>
                        <Th :sort="false"></Th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="estimate in state.sortedValues['overview-estimates']" :key="estimate.id">
                        <Td :class="{ 'line-through': estimate.active !== 1 }">
                            {{ estimate.name }}
                        </Td>
                        <Td>
                            {{ (estimate.active === 1) ? 'Actief' : 'Inactief' }}
                        </Td>
                        <Td class="w-[75px]">
                            <Button
                                htmlType="a"
                                buttonClass="show"
                                size="small"
                                title="Details"
                                :href="route('estimates.detail',  {'id': estimate.id})"
                            />
                            <Button
                                htmlType="a"
                                buttonClass="edit"
                                size="small"
                                title="Bewerken"
                                :href="route('estimates.edit', { 'estimate': estimate.id })"
                            />
                        </Td>
                    </tr>
                </tbody>
            </Table>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import TableSearch from '@/Components/TableSearch.vue'
import Modal from '@/Components/Modal.vue'
import Input from '@/Components/Input.vue'
import Form from '@/Components/Form.vue'
import Select from '@/Components/Select.vue'

import store from '@/store'
import moment from "moment"
import { onMounted, ref } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
import { Inertia } from "@inertiajs/inertia"

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        TableSearch,
    },
    props: [
        'estimates',
    ],
    setup (props){


        return {
            state: store.state,
            ...store,
        }
    },
}

</script>
